module.exports = __webpack_public_path__ + "static/media/012.de349e9a.jpg";